<template>
	<div class="container-fluid">
		<service-contract-toolbar  :customer-name="customerName"></service-contract-toolbar>

		<template v-if="$store.serviceContract">
		<widget>
			<div class="d-flex justify-content-between align-items-center">
				<h2 class="m-0">{{ $store.serviceContract.contract_description ? $store.serviceContract.contract_description : 'Contract' }}
					<br>
					<small class="text-muted">{{customerName}}</small>
				</h2>
				<div>
					<context-menu :menu-items="[
							{text: 'Clone Contract',icon:'fa-copy',clickFunction:'cloneContract'},
							{text: 'Delete Contract',icon:'fa-trash',itemClass:'text-danger',clickFunction:'confirmDeleteContract'}
						]"
						v-on:confirmDeleteContract="confirmDeleteContract"
						v-on:cloneContract="cloneContract">
					</context-menu>
				</div>
			</div>
		</widget>

		<div class="row">
			<div class="col-xl-6">
				<widget class='form' title="Contract Details">
					<vue-form v-on:submit="saveContract" :no-top-button="true" :working="working">

						<field
							label="Contract Type"
							col-class="col-lg-3 col-sm-3 col-sm-6"
							:params="{type:'select',options: [
								{text: 'Schedule of Values',value:'scheduleOfValues'},
								{text: 'Product Based',value:'product'},
								{text: 'Fixed Price Subscription',value:'fixedPrice'},
							]}"
							v-model="$store.serviceContract.contract_type"
							:invalid="$store.errorList.contract_type"
							v-on:change="contractTypeChange">
						</field>

						<field
							label="Customer"
							col-class="col-lg-3 col-sm-3 col-sm-6"
							:params="{type:'select',options:$store.customerOptions}"
							v-model="$store.serviceContract.customer_id"
							:invalid="$store.errorList.customer_id"
							v-on:change="customerChange">
						</field>

						<hr>

						<field
							label="Internal Reference #"
							col-class="col-xl-6 col-lg-4 col-md-4 col-sm-6"
							v-model="$store.serviceContract.contract_num"
							:invalid="$store.errorList.contract_num">
						</field>

						<field v-if="!editingRefNum" :label="customerReferenceNumLabel"
							col-class="col-xl-6 col-lg-4 col-md-4 col-sm-6"
							v-on:clickLabel="editRefNum"
							v-model="$store.serviceContract.customer_reference_num"
							:invalid="$store.errorList.customer_reference_num">
						</field>

						<div v-else class="row">
							<div class="col-xl-6 col-lg-8 col-md-8 col-sm-6">
								<field
									v-model="$store.serviceContract.customer_reference_label"
									:invalid="$store.errorList.customer_reference_label"
									v-on:blur="editingRefNum = false">
								</field>
							</div>
							<div class="col-xl-6 col-lg-4 col-md-4 col-sm-6">
								<field
									v-model="$store.serviceContract.customer_reference_num"
									:invalid="$store.errorList.customer_reference_num">
								</field>
							</div>
						</div>

						<field
							label="Customer Purchase Order #"
							col-class="col-xl-6 col-lg-4 col-md-4 col-sm-6"
							v-model="$store.serviceContract.customer_po"
							:invalid="$store.errorList.customer_po">
						</field>

						<hr>

						<field
							label="Contract Description"
							col-class="col-xl-4 col-lg-3 col-md-4 col-sm-5"
							v-model="$store.serviceContract.contract_description"
							:invalid="$store.errorList.contract_description">
						</field>

						<template v-if="$store.serviceContract.contract_type == 'fixedPrice'">
							
							<field
								label="Detailed Description"
								col-class="col-xl-4 col-lg-3 col-md-4 col-sm-5"
								:params="{type:'richtext'}"
								v-model="$store.serviceContract.detailed_description"
								:invalid="$store.errorList.detailed_description">
							</field>
							
							<hr>
						</template>

						<field
							label="Start Date"
							col-class="col-xl-4 col-lg-3 col-md-4 col-sm-5"
							:params="{type:'date'}"
							v-model="$store.serviceContract.start_date"
							:invalid="$store.errorList.start_date">
						</field>

						<field
							label="Expiry Date"
							col-class="col-xl-4 col-lg-3 col-md-4 col-sm-5"
							:params="{type:'date'}"
							v-model="$store.serviceContract.end_date"
							:invalid="$store.errorList.end_date">
						</field>

						<field 
							label="Category" 
							col-class="col-xl-4 col-lg-3 col-md-4 col-sm-5" 
							v-model="$store.serviceContract.category_id" 
							:params="{type: 'select', options: categoryOptions}" 
							:invalid="$store.errorList.category_id">
						</field>
						
						<field 
							label="Revenue Code" 
							col-class="col-xl-4 col-lg-3 col-md-4 col-sm-5" 
							v-model="$store.serviceContract.revenue_code_id" 
							:params="{type: 'select', options: revenueCodeOptions}" 
							:invalid="$store.errorList.revenue_code_id">
						</field>

						<template v-for="(union,index) in $store.unions" v-if="$store.projectUnionCollectiveAgreements">

							<field 
								:label="'Compensation Schedule for '+union.union_name" 
								col-class="col-xl-4 col-lg-3 col-md-4 col-sm-5" 
								:params="{type: 'select', options: collectiveAgreementOptions(union.id)}" v-model="unionCollectiveAgreements[union.id]">
							</field>

						</template>

						<field 
							label="Mileage Pay" 
							col-class="col-lg-3 col-sm-3 col-sm-6" 
							v-model="$store.serviceContract.pays_mileage" 
							:params="{type: 'boolean'}" 
							:invalid="$store.errorList.pays_mileage">
						</field>

						<field 
							label="Per Diem Pay" 
							col-class="col-lg-3 col-sm-3 col-sm-6" 
							v-model="$store.serviceContract.pays_perdiem" 
							:params="{type: 'boolean'}" 
							:invalid="$store.errorList.pays_perdiem">
						</field>

					</vue-form>
				</widget>
			</div>
			<div class="col-xl-6">
				<widget v-if="$store.serviceContract.contract_type != 'scheduleOfValues'" class='form' title="Billing">
					<vue-form v-on:submit="saveContract" :no-top-button="true" :working="working">

						<field  v-if="$store.serviceContract.contract_type == 'fixedPrice'"
							label="Annual Price"
							col-class="col-xl-4 col-lg-3 col-md-4 col-sm-5"
							v-model="$store.serviceContract.price"
							:params="{type:'number',step:0.01,placeholder:'0.00'}"
							:invalid="$store.errorList.price">
						</field>

						<field  v-else-if="$store.serviceContract.contract_type == 'product'"
							label="Total Annual Price"
							col-class="col-xl-4 col-lg-3 col-md-4 col-sm-5"
							:value="'$ '+totalCostOfProducts.toCurrency()"
							:params="{type:'number',step:0.01,placeholder:'0.00'}"
							:readonly="true">
						</field>

						<field
							label="Automatic Invoicing"
							col-class="col-xl-4 col-lg-3 col-md-4 col-sm-5"
							v-model="$store.serviceContract.has_automatic_invoicing"
							:params="{type:'boolean'}"
							:invalid="$store.errorList.has_automatic_invoicing">
						</field>

						<template v-if="$store.serviceContract.has_automatic_invoicing == 1">
							<field
								label="Billing Interval"
								col-class="col-xl-4 col-lg-3 col-md-4 col-sm-5"
								v-model="$store.serviceContract.billing_interval_months"
								:params="{type:'select',options:[
									{text: 'Annually',value:12},
									{text: 'Semi-Annually',value:6},
									{text: 'Quarterly',value:3},
									{text: 'Monthly',value:1}
								]}"
								:invalid="$store.errorList.billing_interval_months">
							</field>

							<p>An invoice will be automatically generated and sent every <strong>{{$store.serviceContract.billing_interval_months}}</strong> month(s) for the amount of <strong>${{invoiceIntervalAmount}}</strong> plus taxes.</p>

							<field v-if="customer" label="Invoice Recipients" 
								col-class="col-sm-6 col-md-4"
								:params="{type:'select-multi',options:documentEmailRecipients(customer,customer.SubContacts)}"
								v-model="invoiceRecipients">
							</field>

							<field
								label="Initial Billing Date"
								col-class="col-xl-4 col-lg-3 col-md-4 col-sm-5"
								:params="{type:'date'}"
								v-model="$store.serviceContract.initial_billing_date"
								:invalid="$store.errorList.initial_billing_date">
							</field>

						</template>

					</vue-form>

					<table-list v-if="'contract_type' in $store.serviceContract && ($store.serviceContract.contract_type == 'product' || $store.serviceContract.contract_type == 'fixedPrice')"
						record-name="Invoice"
						:fields="invoiceFields"
						:records="mutatedInvoices"
						has-edit="/invoice/{?}/details"
						id-field="slug"
						edit-button-text="Open">

						<h3>Invoices</h3>
					</table-list>
				</widget>
			</div>

		</div>

		<services-list-widget
			title="Services Under this Contract"
			:show-total-labour-hours="true"
			v-on:fetchServices="fetchContractServices(true)">		
		</services-list-widget>

		<widget title="Comments" v-if="'id' in $store.serviceContract">
			<comment-thread 
				parent-model="ServiceContract"
				:parent-slug="$route.params.slug"
				:thread-id="$store.serviceContract.message_thread_id"
				:thread-subject-reference="'Service Contract #'+$store.serviceContract.customer_reference_num">		
			</comment-thread>
		</widget>

		</template>

		<modal-dialog
			title="Delete Service Contract"
			:modal-visible="deleteContractModalVisible"
			confirm-button-text="Yes, Delete"
			button-class="btn-outline-danger"
			v-on:closeModal="deleteContractModalVisible = false"
			v-on:confirm="deleteServiceContract">

			Are you sure you want to delete this service contract?

		</modal-dialog>

	</div>
</template>
<script type="text/javascript">
import Field from "@/components/Field"
import TableList from "@/components/TableList"
import VueForm from "@/components/VueForm"
import ModalDialog from "@/components/ModalDialog"
import ServiceContractToolbar from "./ServiceContractToolbar"
import Widget from "@/components/Widget"
import ContextMenu from "@/layout_fragments/ContextMenu"
import InfoBox from "@/components/InfoBox"
import ServicesListWidget from "@/components/super_components/ServicesListWidget"
import CommentThread from "@/components/super_components/CommentThread"

import ServiceContractMixins from "@/mixins/ServiceContractMixins.js"
import ServiceMixins from "@/mixins/ServiceMixins.js"
import InvoiceMixins from "@/mixins/InvoiceMixins.js"
import ContactMixins from "@/mixins/ContactMixins.js"

export default {
	name: "ServiceContractDetails",
	components: {
		ServiceContractToolbar,
		TableList,
		VueForm,
		Field,
		ModalDialog,
		Widget,
		ContextMenu,
		InfoBox,
		ServicesListWidget,
		CommentThread
	},
	mixins: [ServiceContractMixins,ServiceMixins,InvoiceMixins,ContactMixins],
	data() {
		return {
			working: false,
			deleteContractModalVisible: false,
			editingRefNum: false,
			customer: {},
			invoiceRecipients: [],
			unionCollectiveAgreements: {},
			invoiceFields: [
				{label: "Status",key:"status"},
				{label: "Invoice #",key: 'jobTypeNum',type:'link'},
				{label: "Amt. Total",key: 'grand_total',align:"right"},
				{label: "Amt. Paid",key:"amount_paid",align:"right"},
				{label: "Issue Date", key: "issueDate"},
				{label: "Due Date",key: 'dueDate'},
				{label: "Age",key: 'age'},
				{label: "Processed",key: 'is_processed',type:"boolean",align:'center'},
			]
		}
	},
	computed: {
		customerReferenceNumLabel() {
			let label = this.$store.serviceContract.customer_reference_label ? this.$store.serviceContract.customer_reference_label : 'Customer Reference #'

			label += " <i class='fa fa-pencil-alt icon-button'></i>"

			return label
		},
		invoiceIntervalAmount() {

			let amount = 0

			if (this.$store.serviceContract.contract_type == "fixedPrice")
				amount = +this.$store.serviceContract.price * +this.$store.serviceContract.billing_interval_months / 12
			else if (this.$store.serviceContract.contract_type == "product")
				amount  = this.totalCostOfProducts * +this.$store.serviceContract.billing_interval_months / 12

			return amount.toCurrency()
		}
	},
	methods: {
		editRefNum() {
			if (!this.$store.serviceContract.customer_reference_label)
				this.$store.serviceContract.customer_reference_label = "Customer Reference #"

			this.editingRefNum = true
		},
		contractTypeChange() {
			if ("id" in this.$store.serviceContract) {
				this.$nextTick(() => {
					this.saveContract()
				})
			}
		},
		customerChange(customer_id) {
			let vm = this

			let params = {
				include: ["Contact"]
			}

			this.getJSON("Contact/find/"+customer_id,params).then(response => {
				if (response.success)
					vm.customer = response.data
			})
		},
		openInvoice(inv) {
			window.open(window.apiBase+"ServiceInvoice/pdf?slug="+inv.slug+"&token="+this.$store.sessionToken,"_blank")
		},
		deleteInvoice(inv) {
			let vm = this

			this.postData("ServiceInvoice/save",{id:inv.id,finalized:0,skipQBOPush:true},true).then(response => {
				if (response.success) {
					vm.postData("ServiceInvoice/delete",{id:inv.id},true).then(response => {
						vm.fetchContractInvoices()
					})
				}
			})
		},
		saveContract() {
			let vm = this

			this.working = true

			let payload = this.cloneObj(this.$store.serviceContract)

			let deleteFields = ["Service","Customer","User","ServiceProduct","updated_at","updated_by","created_at","tenant_id"]
			deleteFields.forEach(key => {
				delete payload[key]
			})

			payload.collective_agreements_json = JSON.stringify(this.$store.projectUnionCollectiveAgreements)
			
			let recipientOptions = this.documentEmailRecipients(this.customer,this.customer.subContactList)
			payload.invoice_recipients_json = JSON.stringify(this.invoiceRecipients)

			payload.collective_agreements_json = JSON.stringify(vm.unionCollectiveAgreements)

			if (this.$route.params.slug != "new") {

				delete payload.ServiceContractTask
				delete payload.Material

				let taskPayload = {
					records: this.$store.serviceContract.ServiceContractTask
				}

				taskPayload.records = JSON.stringify(taskPayload.records.map(task => {

					task.contract_id = vm.$store.serviceContract.id
					return task
				}))

				let promises = [
					this.postData("ServiceContract/save",payload),
					this.postData("ServiceContractTask/save-batch",taskPayload)
				]

				Promise.all(promises).then(responses => {
					vm.working = false

					if (responses[0].success && responses[1].success) 
						vm.alertSaved("Contract saved")
					else {
						responses.forEach(response => {
							if (!response.success) {
								if ("errors" in response)
									vm.alertErrors(response.errors)
								else if ("message" in response)
									vm.alertFail(response.message)

							}
						})
					}

				})
			}
			else {
				//this is a save of a new contract, we need to save to Contract model first to get id

				/*let taskPayload = {
					records: payload.ServiceContractTask
				}*/

				delete payload.ServiceContractTask
				delete payload.Material

				this.postData("ServiceContract/save",payload,true).then(response => {
					vm.working = false
					if (response.success) {

						if (response.success) {

							if (this.$route.params.slug == 'new') {
								vm.alertSaved("New Contract Saved")
								vm.$router.push("/service-contract/"+response.slug+"/details")
							}
							else
								vm.alertSaved("Contract saved")
							
						}

						/*taskPayload.records = taskPayload.records.map(task => {
							task.contract_id = response.record_id
							return task
						})

						vm.postData("ServiceContractTask/save-batch",taskPayload,true).then(taskResponse => {
							vm.working = false
							if (taskResponse.success) {
								vm.alertSaved("New Contract Saved")
								vm.$router.push("/service-contract/"+response.slug)
							}
						})*/
					}
				})
			}
		},
		confirmDeleteContract() {
			this.deleteContractModalVisible = true
		},
		deleteServiceContract() {
			let vm = this

			this.postData("ServiceContract/delete",{id:this.$store.serviceContract.id}).then(response => {
				vm.deleteContractModalVisible = false
				vm.$router.push("/service-contracts")
			})
		},
		cloneContract() {
			let vm = this

			let fields = [
				"contract_num",
				"customer_reference_num",
				"customer_reference_label",
				"contract_description",
				"customer_id",
				"contract_type",
				"pays_mileage",
				"pays_perdiem",
				"category_id",
				"revenue_code_id",
				"detailed_description",
				"price",
				"invoice_recipients_json",
				"collective_agreements_json",
				"customer_po"
			]

			let params = {
				include: [
					"ServiceContractTask",
					"Material",
					"ServiceProduct",
					"User",
				]
			}

			this.getJSON("ServiceContract/find/"+this.$store.serviceContract.slug,params).then(contractResponse => {
				if (contractResponse.success) {

					let payload = {}

					fields.forEach(key => {
						payload[key] = vm.$store.serviceContract[key]
					})

					payload.contract_description += " (clone)"

					if (contractResponse.data.Material)
						payload.Material = contractResponse.data.Material.map(mat => mat.material_id)

					vm.postData("ServiceContract/save",payload,true).then(saveResponse => {
						if (saveResponse.success) {

							let promises = []

							let tasksPayload = false
							if (contractResponse.data.ServiceContractTask) {

								tasksPayload = {}
								tasksPayload.records = JSON.stringify(contractResponse.data.ServiceContractTask.map(task => {
									return {
										contract_id: saveResponse.data.record_id,
										description: task.description,
										item_number: task.item_number,
										sort_order: task.sort_order,
										unit_price: task.unit_price
									}
								}))
							}

							if (tasksPayload)
								promises.push(vm.postData("ServiceContractTask/save-batch",tasksPayload))

							if (contractResponse.data.User) {
								let condensedToUser = []
								contractResponse.data.User.forEach(user => {
									let userIndex = condensedToUser.findIndex(addedUser => addedUser.id == user.user_id)

									if (userIndex >= 0) {
										condensedToUser[userIndex].JobPersonnelRole['set'].push(user.personnel_role_id)
									}
									else {
										condensedToUser.push({
											id: user.user_id,
											JobPersonnelRole: {
												'set': [user.personnel_role_id],
												other_field: "service_contract_id",
												other_id: saveResponse.data.record_id
											}
										})
									}
								})

								condensedToUser.forEach(userPayload => {
									promises.push(vm.postData("User/save",userPayload))
								})
							}

							if (contractResponse.data.ServiceProduct) {
								let productsPayload = {
									records: JSON.stringify(contractResponse.data.ServiceProduct.map(prod => {
										return {
											service_contract_id: saveResponse.data.record_id,
											product_id: prod.product_id,
											qty: prod.qty
										}
									}))
								}

								promises.push(vm.postData("ServiceContractProduct/save-batch",productsPayload))
							}

							Promise.all(promises).then(responses => {
								vm.alertSaved("Contract cloned!")
								vm.$router.push("/service-contract/"+saveResponse.data.slug+"/details")
							})
						}
					})
				}
			})
		},
		fetchContractInvoices() {
			let vm = this

			let params = {
				filters: [
					["service_contract_id",this.$store.serviceContract.id]
				],
				include: [{model: "Service",fields: ["id","slug","job_name","job_num"]}]
			}

			this.getJSON("ServiceInvoice/get",params).then(response => {
				if (response.success)
					vm.$store.invoices = response.data
			})
		},
		fetchContractProducts(contract_slug) {
			let vm = this

			let params = {
				include: ["ServiceProduct"],
				fields: ["id","slug","ServiceProduct"]
			}

			this.getJSON("ServiceContract/find/"+contract_slug,params).then(response => {
				if (response.success)
					vm.$store.serviceContract.ServiceProduct = vm.cloneObj(response.data.ServiceProduct)
			})
		},
		fetchContractServices(spinner) {
			let vm = this

			let filters = []

			if (this.filteringFilters) 
				filters = this.filteringFilters

			if (typeof filters == 'object' && "a" in filters) {
				filters.a.push(["contract_id",this.$store.serviceContract.id])
				filters.a.unshift(["contract_id",this.$store.serviceContract.id])
				filters.b.push(["contract_id",this.$store.serviceContract.id])
			}
			else
				filters.push(["contract_id",this.$store.serviceContract.id])

			return new Promise((resolve,reject) => {

				if (spinner)
					this.spinner(true)

				let include = [
					{model: "Contact",fields:["name"]},
					{model: "TimeLog",fields:["id","slug","regular_hours","overtime_hours_15x","overtime_hours_2x","overtime_hours_25x","submitted_by"]},
					"ContactLocation",

				]
		
				let promises = []
				if ("a" in filters) {
					let params = {
						filters: filters.a,
						include,
						fields: ["id","slug","job_num","job_name","status","description","Customer","address","city","province","country","postal_code"]
					}

					promises.push(this.getJSON("Service/get",params,true))

					params.filters = filters.b
					promises.push(this.getJSON("Service/get",params,true))
				}
				else {
					let params = {
						filters,
						include,
						fields: ["id","slug","job_num","job_name","status","description","Customer","address","city","province","country","postal_code"]
					}
					promises.push(this.getJSON("Service/get",params,true))
				}

				Promise.all(promises).then(responses => {
					vm.spinner(false)

					vm.$store.services = []

					responses.forEach(response => {
						if (response.success) {
							vm.$store.services = [
								...vm.$store.services,
								...response.data
							]
						}
					})

					//remove duplicates
					let cleanedServices = []
					vm.$store.services.forEach(service => {
						if (!cleanedServices.find(cleanedService => cleanedService.id == service.id))
							cleanedServices.push(service)
					})
					vm.$store.services = cleanedServices

					resolve(responses)
				})
			})
		},
		fetchData() {
			let vm = this

			return new Promise((resolve,reject) => {
				let promises = [
					vm.fetchCustomers(),
					vm.fetchJobCategories(),
					vm.fetchRevenueCodes(),
					vm.fetchUnions()
				]

				vm.spinner(true)

				Promise.all(promises).then(responses => {
					vm.spinner(false)

					resolve(responses)
				})
			})
		}
	},
	created() {
		let vm = this

		this.fetchData().then(responses => {

			vm.$store.serviceFilterArchiveValue = 'all'

			if (vm.$route.params.slug != "new") {
				vm.fetchContractIfNotSet(vm.$route.params.slug).then(response => {

					if (!vm.$store.serviceContract || !vm.$store.serviceContract.id)
						return

					vm.fetchContractServices(false)
					vm.fetchContractInvoices()
					vm.customer = response.data && response.data.Customer ? vm.cloneObj(response.data.Customer) : null

					try {
						let unionCollectiveAgreements = JSON.parse(response.data.collective_agreements_json)

						if (Array.isArray(unionCollectiveAgreements))
							vm.unionCollectiveAgreements = {}
						else
							vm.unionCollectiveAgreements = unionCollectiveAgreements

						vm.$store.unions.forEach(union => {
							if (!(union.id in vm.unionCollectiveAgreements))
								vm.unionCollectiveAgreements[union.id] = null
						})
					}
					catch (e) {}

					try {
						vm.invoiceRecipients = JSON.parse(response.data.invoice_recipients_json)
					}
					catch (e) {
						vm.invoiceRecipients = []
					}
					vm.fetchContractProducts(vm.$store.serviceContract.slug)

				})
			}
			else {
				vm.$store.serviceContract = {}

				if ('query' in vm.$route && vm.$route.query && 'customer_id' in vm.$route.query && vm.$route.query.customer_id) {
					vm.$store.serviceContract.customer_id = vm.$route.query.customer_id
					vm.customerChange(vm.$route.query.customer_id)
				}
			}
		})
	}
}
</script>